import { createComponent as _$createComponent } from "solid-js/web";
import { Shell } from "../shell/Shell.tsx";

/**
 * `/` — the game itself (AD-001's "the game lives at root"), which under
 * AD-009 means the original 1990 Red Baron shell: the intro sequence on first
 * entry, then the Main Menu, both drawn on a logical 320×200 canvas from the
 * baked original artwork. All of it lives in `../shell/`.
 */
export function Home() {
  return _$createComponent(Shell, {});
}